export enum ListType {
  NUMBERS = 'NUMBERS',
  LETTERS = 'LETTERS',
  BULLETS = 'BULLETS',
}
